import React from "react";
import { X, BookPlus } from "lucide-react";

export default function NewBookModal({
  children,
  onClose,
  title = "Add / Edit New Book",
  badge = "Single Entry",
}) {
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-xs flex items-center justify-center z-50 p-4 animate-fade-in">
      <div className="bg-[#131110] border border-[#2e2720] rounded-2xl shadow-2xl w-full max-w-2xl flex flex-col max-h-[90vh] overflow-hidden">
        
        {/* HEADER BLOCK */}
        <div className="p-4 sm:p-5 border-b border-[#2e2720] flex items-center justify-between bg-[#1a1613] shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-400 flex items-center justify-center">
              <BookPlus className="w-4 h-4 stroke-[2]" />
            </div>
            <div className="space-y-0.5">
              <div className="text-[10px] font-bold uppercase tracking-widest text-amber-400 bg-amber-500/10 border border-amber-500/20 px-2 py-0.5 rounded-md w-max">
                {badge}
              </div>
              <h2 className="text-sm font-bold tracking-tight text-stone-100">
                {title}
              </h2>
            </div>
          </div>
          <button
            type="button"
            className="p-1.5 text-stone-400 hover:text-stone-100 hover:bg-[#25201b] rounded-xl transition-colors focus:outline-none"
            onClick={onClose}
          >
            <X className="w-4 h-4 stroke-[2.5]" />
          </button>
        </div>

        {/* SCROLLABLE FORM BODY */}
        <div className="flex-1 overflow-y-auto p-5 sm:p-6 custom-scrollbar [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-[#131110] [&::-webkit-scrollbar-thumb]:bg-[#2a241e] [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-amber-500">
          {children}
        </div>

      </div>
    </div>
  );
}